import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FlatList, View } from 'react-native';
import { getQuickSelectionWidgetStyles } from './QuickSelectionWidgetStyles';
import { QuickSelectionWidgetVariantTypes } from './QuickSelectionWidgetPropTypes';
import { withBoundaries } from '../../hoc';
import { Card, getTestId, useBreakpoint, isValidObject } from '@airtel/air-design-system';
import { SectionTitleWidget } from '../section-title-widget';
import { updateListItem } from './QuickSelectionWidgetUtils';
import { SingleLineItem } from './components/single-line-item/SingleLineItem';
var QuickSelectionWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'QuickSelectionWidget' : _props$testID,
    style = props.style,
    headerStyle = props.headerStyle,
    _props$withCardBackgr = props.withCardBackground,
    withCardBackground = _props$withCardBackgr === void 0 ? false : _props$withCardBackgr,
    headerTitle = props.headerTitle,
    _props$selectionType = props.selectionType,
    selectionType = _props$selectionType === void 0 ? 'single' : _props$selectionType,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? QuickSelectionWidgetVariantTypes.SINGLE_LINE : _props$variant,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    onUserAction = props.onUserAction,
    _props$numberOfColumn = props.numberOfColumns,
    numberOfColumns = _props$numberOfColumn === void 0 ? 1 : _props$numberOfColumn,
    containerProps = props.containerProps,
    listProps = props.listProps;
  var _useState = useState(list),
    quickSelectionList = _useState[0],
    setQuickSelectionList = _useState[1];
  variant == QuickSelectionWidgetVariantTypes.SINGLE_LINE;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var quickSelectionWidgetStyles = getQuickSelectionWidgetStyles(isLargeScreen);
  var Container = withCardBackground ? Card : View;
  useEffect(() => {
    var timeoutId;
    if (Array.isArray(list)) {
      try {
        if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
          list === null || list === void 0 ? void 0 : list.forEach((item, index) => {
            if (isValidObject(item) && isValidObject(item === null || item === void 0 ? void 0 : item.onItemVisibleMetaData)) {
              onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, item === null || item === void 0 ? void 0 : item.onItemVisibleMetaData), Object.assign({
                index
              }, item));
            }
          });
        }
        timeoutId = setTimeout(() => {
          setQuickSelectionList(list);
        }, 50);
      } catch (error) {
        timeoutId = setTimeout(() => {
          setQuickSelectionList(list);
        }, 50);
      }
    }
    return () => timeoutId && clearTimeout(timeoutId);
  }, [list]);
  var _onItemPress = _ref => {
    var item = _ref.item,
      index = _ref.index;
    var updatedList = updateListItem({
      item,
      index
    }, quickSelectionList, selectionType);
    var id = item.id,
      onPress = item.onPress;
    setQuickSelectionList(updatedList);
    var selectedList = updatedList === null || updatedList === void 0 ? void 0 : updatedList.filter(_item => _item === null || _item === void 0 ? void 0 : _item.isSelected);
    (item === null || item === void 0 ? void 0 : item.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onPress), {
      selectedList,
      currentItem: item,
      currentIndex: index
    }));
  };
  var renderItem = _ref2 => {
    var item = _ref2.item,
      index = _ref2.index;
    return _jsx(SingleLineItem, {
      index: index,
      item: item,
      onItemPress: () => {
        _onItemPress({
          item,
          index
        });
      },
      itemCount: quickSelectionList.length,
      numberOfColumns: numberOfColumns,
      testID: testID
    });
  };
  return _jsxs(Container, Object.assign({}, getTestId(testID), {
    style: [quickSelectionWidgetStyles.container, style]
  }, containerProps, {
    children: [headerTitle && _jsx(SectionTitleWidget, Object.assign({
      onUserAction: onUserAction,
      style: [quickSelectionWidgetStyles.header, headerStyle]
    }, headerTitle)), variant == QuickSelectionWidgetVariantTypes.SINGLE_LINE && _jsx(FlatList, Object.assign({
      data: quickSelectionList,
      renderItem: renderItem,
      keyExtractor: (_, index) => "quick_selection_item_" + index,
      numColumns: numberOfColumns
    }, listProps, getTestId(testID, 'quickSelectionListContainer')), numberOfColumns)]
  }));
};
QuickSelectionWidgetComponent.genericRendererKey = 'AirQuickSelectionWidget';
export var QuickSelectionWidget = withBoundaries(QuickSelectionWidgetComponent);